
export const CHANGE_PAGE = "[FULL REPORT TABLE] CHANGE_PAGE";
export const LOAD_TOP_WORDS_PAGINATED = "[FULL REPORT TABLE] LOAD_TOP_WORDS_PAGINATED";
export const SEARCH_CHANGE = "[FULL REPORT TABLE] SEARCH_CHANGE";


// WEBPACK FOOTER //
// ./src/modules/full-report-top-words/full-report-top-words-action-types.js